import React, { useState } from "react";
import { Form, Button, Row, Col, Drawer, Spin } from "antd";
import { vsmNotify, vsmKitty } from "../../../../config/messages";
import useStore from "../../../../store";
import { observer } from "mobx-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import InputComponent from "../../../../component/InputComponent";
import moment from "moment";
import debounce from "lodash/debounce";
import { default_roles } from "../../../../utils/GlobalFunction";

const AddComponent = observer((props) => {
	const [form] = Form.useForm();
	const {
		ManageKittyStore,
		ManageKittyStore: { AddData }
	} = useStore();
	const [saving, setSaving] = useState();
	const [disabled, setDisabled] = useState(true);
	const [fetchLocation, setFetchLocation] = useState(true);
	const dateFormat = "DD/MM/YYYY";

	// Handle submit and call function to save new record
	const handleSubmit = (data) => {
		setSaving(true);
		// data.user_id = 75;
		data.start_date = moment(data.start_date).format("YYYY-MM-DD");
		data.end_date = moment(data.end_date).format("YYYY-MM-DD");
		AddData(data)
			.then((data) => {
				close();
				vsmNotify.success({
					message: data.STATUS.NOTIFICATION[0],
				});
			})
			.catch((e) => {
				if (e.errors) {
					form.setFields(e.errors);
				}
			})
			.finally(() => setSaving(false));
	};


	// check for valid form values then accordingly make save button disable / enable
	const handleChange = debounce(() => {
		form
			.validateFields()
			.then((data) => {
				setDisabled(false);
			})
			.catch((e) => {
				setDisabled(true);
			});
	}, 500);

	const handleLocationChange = () => {
		const role_id = [default_roles.vp];
		const location_id = form.getFieldValue('location_id');
		form.setFieldsValue({ user_id: null })
		const data = { role_id, location_id };
		ManageKittyStore.getSalesManagerListByLocation(data);
	};


	// reset form and close add form
	const close = () => {
		props.close();
		form.resetFields();
		setFetchLocation(true)
		setDisabled(true);
		ManageKittyStore.dropdown_location_list = null;
		ManageKittyStore.dropdown_sales_manager_list = null;
	};

	return (
		<Drawer
			className="addModal"
			title="New Kitty"
			width="80%"
			visible={props.visible}
			closeIcon={<FontAwesomeIcon icon={faTimes} />}
			onClose={close}
			footer={[
				<Button
					key="2"
					htmlType="button"
					className="cancelBtn mr-35"
					onClick={close}
				>
					Cancel
				</Button>,
				<Button
					key="1"
					disabled={disabled}
					form="addKittyForm"
					loading={saving}
					htmlType="submit"
					type="primary"
				>
					Save
				</Button>,
			]}
		>
			<Form
				form={form}
				id="addKittyForm"
				onFinish={handleSubmit}
				labelCol={{ span: 24 }}
				onChange={handleChange}
			>
				<Row gutter={30}>
					<Col xs={{ span: 24 }} sm={{ span: 8 }} >
						<InputComponent
							type="select"
							autoComplete="chrome-off"
							filterOption="false"
							allowClear
							required
							label="Location"
							name="location_id"
							placeholder="Select location"
							rules={vsmKitty.validation.location_id}
							onChange={() => {
								handleChange();
								handleLocationChange();
							}}
							onFocus={() =>
								fetchLocation &&
								ManageKittyStore.getLocationList().then(() => setFetchLocation(false))
							}
							notFoundContent={
								fetchLocation ? <Spin size="small" /> : "No Record Found."
							}
							options={{
								values: ManageKittyStore.dropdown_location_list,
								value_key: "id",
								text_key: "name",
								rejected_keys:
								ManageKittyStore.dropdown_location_list &&
								ManageKittyStore.dropdown_location_list
										.filter((item) => item.status === 0)
										.map((item) => item.id),
							}}
						/>
					</Col>
					<Col xs={{ span: 24 }} sm={{ span: 8 }} >
						<InputComponent
							type="select"
							allowClear
							required
							disabled={!form.getFieldValue('location_id')}
							autoComplete="chrome-off"
							label="VP"
							name="user_id"
							placeholder="Select VP"
							rules={vsmKitty.validation.user_id}
							onChange={handleChange}
							onFocus={() => handleLocationChange()}
							options={{
								values: ManageKittyStore.dropdown_sales_manager_list,
								value_key: "id",
								text_key: "name",
								rejected_keys:
									ManageKittyStore.dropdown_sales_manager_list &&
									ManageKittyStore.dropdown_sales_manager_list
										.filter((item) => item.status === 0)
										.map((item) => item.id),
							}}
						/>
					</Col>
					<Col xs={{ span: 24 }} sm={{ span: 8 }} >
						<InputComponent
							type="text"
							required
							label="Credits"
							placeholder="Credits"
							name="credits"
							onChange={handleChange}
							rules={vsmKitty.validation.credits}
						/>
					</Col>
					<Col xs={{ span: 24 }} sm={{ span: 8 }} >
						<InputComponent
							type="date"
							mode="date"
							required
							format={dateFormat}
							onChange={handleChange}
							// disabledDate={disabledDate}
							label="Start Date"
							placeholder="Start Date"
							name="start_date"
							rules={vsmKitty.validation.start_date}
						/>
					</Col>
					<Col xs={{ span: 24 }} sm={{ span: 8 }} >
						<InputComponent
							type="date"
							mode="date"
							required
							format={dateFormat}
							onChange={handleChange}
							// disabledDate={disabledDate}
							label="End Date"
							placeholder="End Date"
							name="end_date"
							rules={vsmKitty.validation.end_date}
						/>
					</Col>
				</Row>
			</Form>
		</Drawer>
	);
});

export default AddComponent;
